<nav class="side-nav">
  <div class="nav-header" (click)="navigateTo('/search?tab=patients')" style="cursor: pointer;">
    <div class="app-logo">
      <img src="assets/logo-blue.svg" alt="DaVita" class="logo-image" />
      <div class="app-info">
        <div class="app-name">Support Portal</div>
      </div>
    </div>
  </div>

  <div class="nav-items">
    <div
      *ngFor="let item of navItems"
      class="nav-item"
      [class.active]="isActive(item)"
      [class.disabled]="item.comingSoon"
      (click)="!item.comingSoon && navigateTo(item.route)">
      <mat-icon class="nav-icon">{{ item.icon }}</mat-icon>
      <span class="nav-label">{{ item.label }}</span>
      <span class="coming-soon-badge" *ngIf="item.comingSoon">Soon</span>
    </div>
  </div>

  <div class="nav-footer">
    <app-user-pill></app-user-pill>
  </div>
</nav>
